import React from 'react';

import { useViewerQuery } from '@edx/graphql/generated';

export const ZendeskWidget: React.FC = () => {
  const { data } = useViewerQuery();
  const viewer = data?.viewer;

  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  const zE = typeof window !== 'undefined' && window.zE;

  React.useEffect(() => {
    if (!zE || typeof zE.setLocale !== 'function') return;

    zE.setLocale('es');

    if (viewer) {
      const { firstName, lastName, email } = viewer;
      zE.identify({ name: `${firstName} ${lastName}`, email });
    }
  }, [viewer, zE]);

  return (
    <script
      id="ze-snippet"
      src={`https://static.zdassets.com/ekr/snippet.js?key=${process.env.NEXT_PUBLIC_ZENDESK_KEY}`}
    />
  );
};
